import React, { FunctionComponent, ReactNode, useCallback, useMemo, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Button from "@mui/material/Button";

import "../../../css/filter_bar/trade_filter_dropdown.css";
import DropdownBelow from "./dropdown_below";
import getProjectId from "../../services/getters/project_getters/get_project_id";
import getTradesFilter from "../../services/getters/filter_getters/get_trades_filter";
import getUniformatTrades from "../../services/getters/filter_getters/get_uniformat_trades";
import tradeHidden, { TradeHiddenEvent } from "../../events/selection/trades/trade_hidden";
import tradeHiddenAll, { TradeHiddenAllEvent } from "../../events/selection/trades/trade_hidden_all";
import tradeShown, { TradeShownEvent } from "../../events/selection/trades/trade_shown";
import tradeShownAll, { TradeShownAllEvent } from "../../events/selection/trades/trade_shown_all";
import TreeView from "../shared/tree_view";
import useTrades from "../../queries/trades/use_trades";
import { tradeFilterBreakdown } from "../../services/utilities/trade_filter_breakdown";

import type { Dispatch } from "type_aliases";

export type Props = {
                      disabled?: boolean
                      open: boolean
                      openFlyout: () => void
                      closeFlyout: () => void
                      openNext: () => void
                      openPrevious: () => void
                      tradesTsvFilter: boolean
                      icon?: ReactNode
                    } & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
export const TradeFilterDropdown: FunctionComponent<Props> = function TradeFilterDropdown(props) {
  const { open, disabled, openFlyout, closeFlyout, openNext, openPrevious, projectId, selectedTrades, selectedUniformatTrades, tradeDeselectedAll, tradeSelectedAll, tradeShown, tradeHidden, tradesTsvFilter, icon } = props;

  const { data: trades } = useTrades(projectId);
  const tradeBreakdown = useMemo(() => tradeFilterBreakdown(trades, tradesTsvFilter), [trades, tradesTsvFilter]);

  const [scrollTop, setScrollTop] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const menuRef = useRef<HTMLDivElement>();

  const onFlyoutEntering = useCallback(() => {
    if (menuRef.current.scrollTop !== scrollTop || menuRef.current.scrollLeft !== scrollLeft) {
      menuRef.current.scrollTo({ left: scrollLeft, top: scrollTop, behavior: "auto" });
    }
  }, [scrollLeft, scrollTop]);

  const handleCloseFlyout = useCallback(() => {
    setScrollTop(menuRef.current.scrollTop);
    setScrollLeft(menuRef.current.scrollLeft);
    closeFlyout();
  }, [closeFlyout]);

  return <DropdownBelow
    open={open}
    openFlyout={openFlyout}
    closeFlyout={handleCloseFlyout}
    onFlyoutEntering={onFlyoutEntering}
    disabled={disabled}
    handleOpenNextMenu={openNext}
    handleOpenPreviousMenu={openPrevious}
    buttonContent="Trades"
    icon={icon}
  >
    <div className="TradeFilterDropdown-header">
      Trade Filters
      <div>
        <Button className="TradeFilterDropdown-headerButton" onClick={tradeDeselectedAll} variant="text" color="secondary">
          DESELECT ALL
        </Button>
        <Button className="TradeFilterDropdown-headerButton" onClick={tradeSelectedAll} variant="text" color="secondary">
          SELECT ALL
        </Button>
      </div>
    </div>
    <div className="TradeFilterDropdown-treeContainer" ref={menuRef}>
      <TreeView
        className="TradeFilterDropdown-tree"
        elements={tradeBreakdown}
        selectedElements={tradesTsvFilter ? selectedTrades : selectedUniformatTrades}
        onSelect={tradeShown}
        onDeselect={tradeHidden}
      />
    </div>
  </DropdownBelow>;
};


const mapStateToProps = (state, props) => ({
  selectedUniformatTrades: getUniformatTrades(state, props),
  selectedTrades: getTradesFilter(state, props),
  projectId: getProjectId(state, props)
});

type DispatchedEvents =
  | TradeShownAllEvent
  | TradeHiddenAllEvent
  | TradeShownEvent
  | TradeHiddenEvent

const mapDispatchToProps = (dispatch: Dispatch<DispatchedEvents>) => bindActionCreators({
  tradeSelectedAll: tradeShownAll,
  tradeDeselectedAll: tradeHiddenAll,
  tradeShown,
  tradeHidden
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TradeFilterDropdown);
